import { Button, Divider, Group, Tooltip } from '@mantine/core'
import { Link } from '@remix-run/react'
import { BsLine } from 'react-icons/bs'

type LineButtonWithTooltipProps = {
  label: string
  link: string
  tooltipLabel: React.ReactNode
  w?: string | number
  disabled?: boolean
  onClick?: () => void
}

export const LineButtonWithTooltip = ({
  label,
  link,
  tooltipLabel,
  w,
  disabled,
  onClick,
}: LineButtonWithTooltipProps) => {
  return (
    <Tooltip
      arrowOffset={50}
      label={tooltipLabel}
      opened
      zIndex={1}
      transitionProps={{ duration: 26 }}
    >
      <Button
        justify='space-between'
        leftSection={
          <Group px={0}>
            <BsLine size={36} color='secondary.1' />
            <Divider orientation='vertical' my={0} py={0} />
          </Group>
        }
        rightSection={<span />}
        size='xl'
        component={disabled ? undefined : Link}
        to={link}
        color='success.5'
        mah={80}
        w={w ? w : '100%'}
        fw='bold'
        disabled={disabled}
        onClick={onClick}
      >
        {label}
      </Button>
    </Tooltip>
  )
}
